import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { IClinicalItem, IClinicalItemListRequest } from "./iclinical-item";

@Injectable({ providedIn: 'root' })
export class ClinicalItemService {
    private _clinicalitem: BehaviorSubject<IClinicalItem | null> = new BehaviorSubject<IClinicalItem | null>(null);
    private _clinicalitems: BehaviorSubject<IClinicalItem[]> = new BehaviorSubject<IClinicalItem[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get clinicalitem$(): Observable<IClinicalItem | null> {
        return this._clinicalitem.asObservable();
    }

    get clinicalitems$(): Observable<IClinicalItem[]> {
        return this._clinicalitems.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }



    getClinicalItem(clinicalitem: IClinicalItemListRequest): Observable<BaseRespone<{ pagination: PaginationResult; clinicalItems: IClinicalItem[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; clinicalItems: IClinicalItem[] }>>(`${environment.baseURl}/ClinicalItem/list`, clinicalitem).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._clinicalitems.next(response.result.clinicalItems);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createclinicalItem(clinicalitem: IClinicalItem): Observable<BaseRespone<IClinicalItem>> {
        return this._httpClient.post<BaseRespone<IClinicalItem>>(`${environment.baseURl}/ClinicalItem`, clinicalitem)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newsubcategory) => {
                    return newsubcategory;
                })
            )
    }

    updateClinicalItem(clinicalitem: IClinicalItem): Observable<BaseRespone<IClinicalItem>> {
        return this.clinicalitems$.pipe(
            take(1),
            switchMap(clinicalitems => this._httpClient.put<BaseRespone<IClinicalItem>>(`${environment.baseURl}/ClinicalItem`, clinicalitem).pipe(
                map((updated: BaseRespone<IClinicalItem>) => {

                    // Find the index of the updated product
                    const index = clinicalitems.findIndex(item => item.id === clinicalitem.id);

                    // Update the product
                    clinicalitems[index] = clinicalitem;

                    // Update the products
                    this._clinicalitems.next(clinicalitems);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    deleteClinicalItem(id: number): Observable<BaseRespone<boolean>> {
        return this.clinicalitems$.pipe(
            take(1),
            switchMap(clinicalitem =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/ClinicalItem/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const items = clinicalitem.filter(item => item.id !== id);
                            this._clinicalitems.next(items);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }
}
